// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit_btn {
  font-size: 12px;
}

.avail_toolbar ion-title {
  text-transform: none;
  font-weight: 900;
  font-size: 12px;
  color: #b08d7b;
}

.avail_toolbar.filled {
  box-shadow: 0 0 20px #ad8875;
}

.yellow {
  --background: #e7985b;
}
.yellow ion-label {
  color: #fdefe3;
  font-size: 11px;
  margin-top: 6px;
  margin-left: 4px;
}
.yellow ion-button {
  --color: #fdefe3;
  font-size: 14px;
  border: 1px solid #fdefe3;
  border-radius: 4px;
  padding: 0px 10px;
  margin-top: 5px;
}

.filled {
  background: #242424;
}
.filled ion-title {
  color: #fff;
}

.bag_list {
  margin-bottom: 5vh;
}

.mini_cntr_text {
  text-align: center;
  font-size: 12px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  color: #242424;
}
.mini_cntr_text button {
  background: #ac8875;
  color: #fff;
  padding: 12px;
  border-radius: 3px;
  margin-top: 30px;
}

.bag_item {
  padding-top: 25px;
  padding-bottom: 25px;
  border-bottom: 2px solid #f4e4d0;
}
.bag_item .inline {
  display: inline-flex;
}
.bag_item .owner_row {
  width: 100%;
  justify-content: space-around;
}
.bag_item .owner_row ion-avatar {
  margin-top: -4px;
}
.bag_item .owner_row img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.bag_item .owner_row .price {
  text-align: right;
  width: 50%;
}
.bag_item .owner_row .price label {
  font-size: 10px;
  display: inline;
  white-space: nowrap;
  width: 100%;
}
.bag_item .owner_row .name_stuff * {
  margin: 0;
}
.bag_item .owner_row .name_stuff h3 {
  font-size: 16px;
  color: #8e8e8e;
}
.bag_item .owner_row .name_stuff h4 {
  font-size: 12px;
  color: #8e8e8e;
}
.bag_item .item-grid {
  display: inline-flex;
  overflow-x: scroll;
  width: 97%;
  padding: 20px;
}
.bag_item .item-grid .empty-item {
  border: 1px solid #ecccb1;
  border-radius: 3px;
  min-width: 150px;
  width: -moz-fit-content;
  width: fit-content;
  margin-right: 10px;
  padding: 10px;
  box-sizing: border-box;
}
.bag_item .item-grid .empty-item img {
  width: 150px;
  height: 170px;
  margin-top: -2px;
  background-image: url("/assets/loader.webp");
  background-size: cover;
  background-position: center;
}
.bag_item .item-grid .empty-item h3 {
  color: #c19977;
  font-size: 12px;
  text-align: center;
  padding-top: 10px;
  box-sizing: border-box;
  width: 100%;
  font-weight: 400;
  line-height: 17px;
  width: 100%;
}
.bag_item .item-grid .empty-item h3 ion-icon {
  font-size: 36px;
}
.bag_item .item-grid .empty-item h3 label {
  font-size: 17px;
}
.bag_item .item-grid .empty-item .close_img {
  width: 25px;
  height: 25px;
  color: #fff;
  background: #dbb49f;
  margin-top: -50px;
  margin-left: -10px;
  border-radius: 40px;
  padding: 6px;
}
.bag_item .item-grid .someth {
  min-width: 225px;
}
.bag_item .checkout_button {
  width: 80%;
  padding: 10px;
  background: #dbb49f;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  display: block;
  border-radius: 3px;
  text-transform: uppercase;
  font-weight: 900;
  margin-top: 10px;
}
.bag_item .hollow {
  border: 2px solid #ac8875;
  background: #fff;
  color: #dbb49f;
}

.bag_item:last-child {
  border-bottom: none;
}

.noBagText {
  text-align: center;
  color: #8e8e8e;
  font-size: 14px;
  margin-top: 20vh;
}

.top_card {
  margin-top: -20px;
}

.disabled {
  background: #8e8e8e !important;
}

ion-footer {
  background: #f9f9f9;
  border-top: 1px solid #dbdbdb;
  position: sticky;
  bottom: 0;
  height: 45px;
}
ion-footer ion-button {
  --color: #bba599;
  padding-left: 14px;
  padding-right: 14px;
  text-transform: uppercase;
  font-size: 12px;
  border: 2px solid #bba599;
  font-weight: 800;
  height: 38px;
}
ion-footer .defined_price {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  color: #bba599;
}
ion-footer .filled {
  background: #bba599;
  --color: #fff;
}

.cart_edit_btm_text {
  width: 80%;
  padding: 10px;
  border: 2px solid #dbb49f;
  background: transparent;
  color: #c29a77;
  margin-left: auto;
  margin-right: auto;
  display: block;
  border-radius: 3px;
  text-transform: uppercase;
  font-weight: 900;
  margin-top: 10px;
  text-align: center;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/bag/bag.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAGI;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAR;;AAIA;EACI,4BAAA;AADJ;;AAIA;EACI,qBAAA;AADJ;AAGI;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AADR;AAII;EACI,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFR;;AAMA;EACI,mBAAA;AAHJ;AAKI;EACI,WAAA;AAHR;;AAOA;EACI,kBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAJJ;AAMI;EACI,mBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAJR;;AAQA;EACI,iBAAA;EACA,oBAAA;EACA,gCAAA;AALJ;AAOI;EACI,oBAAA;AALR;AAQI;EACI,WAAA;EACA,6BAAA;AANR;AAQQ;EACI,gBAAA;AANZ;AASQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAPZ;AAUQ;EACI,iBAAA;EACA,UAAA;AARZ;AASY;EACI,eAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAPhB;AAYY;EACI,SAAA;AAVhB;AAaY;EACI,eAAA;EACA,cAAA;AAXhB;AAcY;EACI,eAAA;EACA,cAAA;AAZhB;AAiBI;EACI,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAfR;AAiBQ;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAfZ;AAiBY;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EAEA,4CAAA;EACA,sBAAA;EACA,2BAAA;AAhBhB;AAmBY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAjBhB;AAmBgB;EACI,eAAA;AAjBpB;AAoBgB;EACI,eAAA;AAlBpB;AAsBY;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AApBhB;AAwBQ;EACI,gBAAA;AAtBZ;AA0BI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAxBR;AA2BI;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;AAzBR;;AA6BA;EACI,mBAAA;AA1BJ;;AA6BA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA1BJ;;AA6BA;EACI,iBAAA;AA1BJ;;AA6BA;EACI,8BAAA;AA1BJ;;AA6BA;EAEI,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AA3BJ;AA6BI;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;AA3BR;AA8BI;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AA5BR;AA+BI;EACI,mBAAA;EACA,aAAA;AA7BR;;AAiCA;EACI,UAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA9BJ","sourcesContent":[".edit_btn {\n    font-size: 12px;\n}\n\n.avail_toolbar {\n    ion-title {\n        text-transform: none;\n        font-weight: 900;\n        font-size: 12px;\n        color: #b08d7b;\n    }\n}\n\n.avail_toolbar.filled {\n    box-shadow: 0 0 20px #ad8875;\n}\n\n.yellow {\n    --background: #e7985b;\n\n    ion-label {\n        color: #fdefe3;\n        font-size: 11px;\n        margin-top: 6px;\n        margin-left: 4px;\n    }\n\n    ion-button {\n        --color: #fdefe3;\n        font-size: 14px;\n        border: 1px solid #fdefe3;\n        border-radius: 4px;\n        padding: 0px 10px;\n        margin-top: 5px;\n    }\n}\n\n.filled {\n    background: #242424;\n\n    ion-title {\n        color: #fff;\n    }\n}\n\n.bag_list {\n    margin-bottom: 5vh;\n}\n\n.mini_cntr_text {\n    text-align: center;\n    font-size: 12px;\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 100px;\n    color: #242424;\n\n    button {\n        background: #ac8875;\n        color: #fff;\n        padding: 12px;\n        border-radius: 3px;\n        margin-top: 30px;\n    }\n}\n\n.bag_item {\n    padding-top: 25px;\n    padding-bottom: 25px;\n    border-bottom: 2px solid #f4e4d0;\n\n    .inline {\n        display: inline-flex;\n    }\n\n    .owner_row {\n        width: 100%;\n        justify-content: space-around;\n\n        ion-avatar {\n            margin-top: -4px;\n        }\n\n        img {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n        }\n\n        .price {\n            text-align: right;\n            width: 50%;\n            label {\n                font-size: 10px;\n                display: inline;\n                white-space: nowrap;\n                width: 100%;\n            }\n        }\n\n        .name_stuff {\n            * {\n                margin: 0;\n            }\n\n            h3 {\n                font-size: 16px;\n                color: #8e8e8e;\n            }\n\n            h4 {\n                font-size: 12px;\n                color: #8e8e8e;\n            }\n        }\n    }\n\n    .item-grid {\n        display: inline-flex;\n        overflow-x: scroll;\n        width: 97%;\n        padding: 20px;\n\n        .empty-item {\n            border: 1px solid #ecccb1;\n            border-radius: 3px;\n            min-width: 150px;\n            width: fit-content;\n            margin-right: 10px;\n            padding: 10px;\n            box-sizing: border-box;\n\n            img {\n                width: 150px;\n                height: 170px;\n                margin-top: -2px;\n\n                background-image: url(\"/assets/loader.webp\");\n                background-size: cover;\n                background-position: center;\n            }\n\n            h3 {\n                color: #c19977;\n                font-size: 12px;\n                text-align: center;\n                padding-top: 10px;\n                box-sizing: border-box;\n                width: 100%;\n                font-weight: 400;\n                line-height: 17px;\n                width: 100%;\n\n                ion-icon {\n                    font-size: 36px;\n                }\n\n                label {\n                    font-size: 17px;\n                }\n            }\n\n            .close_img {\n                width: 25px;\n                height: 25px;\n                color: #fff;\n                background: #dbb49f;\n                margin-top: -50px;\n                margin-left: -10px;\n                border-radius: 40px;\n                padding: 6px;\n            }\n        }\n\n        .someth {\n            min-width: 225px;\n        }\n    }\n\n    .checkout_button {\n        width: 80%;\n        padding: 10px;\n        background: #dbb49f;\n        color: #fff;\n        margin-left: auto;\n        margin-right: auto;\n        display: block;\n        border-radius: 3px;\n        text-transform: uppercase;\n        font-weight: 900;\n        margin-top: 10px;\n    }\n\n    .hollow {\n        border: 2px solid #ac8875;\n        background: #fff;\n        color: #dbb49f;\n    }\n}\n\n.bag_item:last-child {\n    border-bottom: none;\n}\n\n.noBagText {\n    text-align: center;\n    color: #8e8e8e;\n    font-size: 14px;\n    margin-top: 20vh;\n}\n\n.top_card {\n    margin-top: -20px;\n}\n\n.disabled {\n    background: #8e8e8e !important;\n}\n\nion-footer {\n    // margin-top: -45px;\n    background: #f9f9f9;\n    border-top: 1px solid #dbdbdb;\n    position: sticky;\n    bottom: 0;\n    height: 45px;\n\n    ion-button {\n        --color: #bba599;\n        padding-left: 14px;\n        padding-right: 14px;\n        text-transform: uppercase;\n        font-size: 12px;\n        border: 2px solid #bba599;\n        font-weight: 800;\n        height: 38px;\n    }\n\n    .defined_price {\n        font-size: 16px;\n        margin-left: 20px;\n        margin-right: 20px;\n        color: #bba599;\n    }\n\n    .filled {\n        background: #bba599;\n        --color: #fff;\n    }\n}\n\n.cart_edit_btm_text {\n    width: 80%;\n    padding: 10px;\n    border: 2px solid #dbb49f;\n    background: transparent;\n    color: #c29a77;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    border-radius: 3px;\n    text-transform: uppercase;\n    font-weight: 900;\n    margin-top: 10px;\n    text-align: center;\n    font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
